export default {
  methods: {
    async resolveShopCartParameterProjectDomainNames (parameter = {}) {
      const domainId = parameter?.extraData?.domain_id
      const projectId = parameter?.project_id
      let project_domain = domainId || '-'
      let project_name = projectId || '-'
      if (domainId) {
        try {
          const { data } = await new this.$Manager('domains').get({ id: domainId })
          project_domain = data?.name || domainId
        } catch (error) {
          project_domain = domainId
        }
      }
      if (projectId) {
        try {
          const { data } = await new this.$Manager('projects').get({
            id: projectId,
            params: { project_domain: domainId },
          })
          project_name = data?.name || projectId
        } catch (error) {
          project_name = projectId
        }
      }
      return { project_domain, project_name }
    },
    parseFlavorConfigString (str = '') {
      // 8C16G210G -> { cpu, memory(MB), disk(MB) }
      const match = /^(\d+)C(\d+(?:\.\d+)?)G(?:(\d+(?:\.\d+)?)G)?$/i.exec(String(str).trim())
      if (!match) return null
      return {
        cpu: Number(match[1]),
        memory: Number(match[2]) * 1024,
        disk: match[3] != null ? Number(match[3]) * 1024 : null,
      }
    },
    buildServerConfFromParameter (data = {}, projectName, server) {
      const p = data.parameter || {}
      const beforeParsed = this.parseFlavorConfigString(p.config_before)
      const afterParsed = this.parseFlavorConfigString(p.config_after)
      const beforeSysDisks = (server?.disks_info || []).filter(item => item.disk_type === 'sys').map(item => ({
        medium_type: item.medium_type,
        size: item.size,
        type: item.storage_type,
      }))
      const beforeDataDisks = (server?.disks_info || []).filter(item => item.disk_type === 'data').map(item => ({
        medium_type: item.medium_type,
        size: item.size,
        type: item.storage_type,
      }))
      // 未调整磁盘时 parameter.disks 可能为空，调整后沿用原磁盘
      const afterDataDisks = (p.disks && p.disks.length) ? p.disks : beforeDataDisks
      return [{
        name: p.generate_name || data.resourceData?.name || server?.name || data.name || '-',
        project: projectName || p.extraData?.project || data.project || server?.tenant || '-',
        hypervisor: p.hypervisor || server?.hypervisor,
        before: {
          cpu: beforeParsed?.cpu ?? server?.vcpu_count,
          memory: beforeParsed?.memory ?? server?.vmem_size,
          disk: beforeParsed?.disk ?? server?.disk,
          sku: server?.instance_type,
          dataDisks: beforeDataDisks,
          sysDisks: beforeSysDisks,
        },
        after: {
          cpu: p.vcpu_count || afterParsed?.cpu,
          memory: p.vmem_size || afterParsed?.memory,
          disk: afterParsed?.disk ?? server?.disk,
          sku: p.sku,
          dataDisks: afterDataDisks,
          sysDisks: beforeSysDisks,
        },
      }]
    },
    normalizeChangeConfigServerConfItem (item = {}, server, projectName) {
      const beforeSysDisks = (item.before?.sysDisks?.length
        ? item.before.sysDisks
        : (server?.disks_info || []).filter(d => d.disk_type === 'sys').map(d => ({
          medium_type: d.medium_type,
          size: d.size,
          type: d.storage_type,
        })))
      const beforeDataDisks = (item.before?.dataDisks?.length
        ? item.before.dataDisks
        : (server?.disks_info || []).filter(d => d.disk_type === 'data').map(d => ({
          medium_type: d.medium_type,
          size: d.size,
          type: d.storage_type,
        })))
      const afterSysDisks = item.after?.sysDisks?.length ? item.after.sysDisks : beforeSysDisks
      const afterDataDisks = item.after?.dataDisks?.length ? item.after.dataDisks : beforeDataDisks
      return {
        ...item,
        project: (item.project && item.project !== '-') ? item.project : (projectName || server?.tenant || '-'),
        hypervisor: item.hypervisor || server?.hypervisor,
        before: {
          ...(item.before || {}),
          dataDisks: beforeDataDisks,
          sysDisks: beforeSysDisks,
        },
        after: {
          ...(item.after || {}),
          dataDisks: afterDataDisks,
          sysDisks: afterSysDisks,
          disk: item.after?.disk ?? server?.disk,
        },
      }
    },
    async resolveServerInfo (data = {}) {
      const serverId = data.resource_id || data.parameter?.id
      if (!serverId) return null
      try {
        const { data: server } = await new this.$Manager('servers').get({
          id: serverId,
          params: { scope: this.$store.getters.scope },
        })
        return server || null
      } catch (e) {
        return null
      }
    },
    async resolveChangeConfigServerConfList (data = {}) {
      const server = await this.resolveServerInfo(data)
      const projectName = data.parameter?.extraData?.project || data.project || server?.tenant || '-'
      let conf = data.parameter?.extraData?.serverConf ??
        data.serverConf ??
        data.parameter?.serverConf
      if (typeof conf === 'string') {
        try {
          conf = JSON.parse(conf)
        } catch (e) {
          conf = null
        }
      }
      if (conf) {
        const list = Array.isArray(conf) ? conf : [conf]
        return list.map(item => this.normalizeChangeConfigServerConfItem(item, server, projectName))
      }
      // orderset 未持久化 serverConf 时，用 parameter + 主机磁盘信息兜底重建
      return this.buildServerConfFromParameter(data, projectName, server)
    },
    async handleViewShopCart (data, rets) {
      const isChangeConfig = data.action === 'perform' && data.perform_action_name === 'change-config'
      if (isChangeConfig) {
        const serverConfList = await this.resolveChangeConfigServerConfList(data)
        const variables = {
          serverConf: JSON.stringify(serverConfList),
          change_type: data.parameter?.extraData?.change_type || data.extraData?.change_type || 'change-config',
        }
        this.createDialog('WorkflowResourceViewDialog', {
          orderSetResId: this.variables.ids,
          orderSetIdx: rets.rowIndex,
          isChangeConfig: true,
          serverConfList,
          workflowData: { ...this.data, variables },
          variables,
          serverData: data.parameter || {},
        })
        return
      }
      const serverData = { ...data.parameter, __count__: data.count }
      const { project_domain, project_name } = await this.resolveShopCartParameterProjectDomainNames(data.parameter)
      const variables = {
        project_domain,
        project_name,
        'server-create-paramter': JSON.stringify(serverData),
      }
      this.createDialog('WorkflowResourceViewDialog', {
        orderSetResId: this.variables.ids,
        orderSetIdx: rets.rowIndex,
        workflowData: { ...this.data, variables },
        variables,
        serverData,
      })
    },
  },
}
